import { protectedRoutes, publicRoutes } from "configs/routes.config";
import appConfig from "configs/app.config";
import PageContainer from "components/template/pageContainer";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ProtectedRoute from "components/route/protectedRoute";
import PublicRoute from "components/route/publicRoute";
import AuthorityGuard from "components/route/authorityGuard";
import AppRoute from "components/route/appRoute";
import { UserAuthContextProvider } from "context/userAuthContext";

const { mainEntryPath } = appConfig;

const AllRoutes = (props) => {
  const userAuthority = useSelector(
    (state) => state?.auth?.user.userData.authority
  );

  return (
    <UserAuthContextProvider>
      <Routes>
        <Route path="/" element={<ProtectedRoute />}>
          <Route path="/" element={<Navigate replace to={mainEntryPath} />} />
          {protectedRoutes.map((route, index) => (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <AuthorityGuard
                  userAuthority={userAuthority}
                  authority={route.authority}
                >
                  <PageContainer {...props} {...route.meta}>
                    <AppRoute
                      routeKey={route.key}
                      component={route.component}
                      {...route.meta}
                    />
                  </PageContainer>
                </AuthorityGuard>
              }
            />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
        <Route path="/" element={<PublicRoute />}>
          {publicRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          ))}
        </Route>
      </Routes>
    </UserAuthContextProvider>
  );
};

const Views = (props) => {
  return <AllRoutes {...props} />;
};

export default Views;
